import { useTranslation } from 'react-i18next';

import { GraphChartConfigDto, LineChartDataDto, TimelineChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import { useLineChartData, useTimelineChartData } from 'hooks/useLineChartData';
import LineChart from 'components/LineChart/LineChart';

export const PlayerLineChart = ({ chartData, isLoading, extraChartData }: ChartProps<LineChartDataDto, GraphChartConfigDto>) => {
  const { t } = useTranslation();

  const chartDataDisplay = useLineChartData(chartData?.datasets, isLoading);

  return <LineChart xLabel={''} yLabel={t(extraChartData.yAxis)} chartData={chartDataDisplay} xStepSize={1} />;
};

export const PlayerTimelineChart = ({ chartData, isLoading, extraChartData }: ChartProps<TimelineChartDataDto, GraphChartConfigDto>) => {
  const { t } = useTranslation();

  const chartDataDisplay = useTimelineChartData(chartData?.datasets, isLoading);

  return <LineChart xLabel={''} yLabel={t(extraChartData.yAxis)} chartData={chartDataDisplay} />;
};
